import { Award, TrendingDown, Minus } from 'lucide-react';
import { ClientRating } from '../hooks/useClientRatings';

interface ClientRatingBadgeProps {
  rating: ClientRating;
  size?: 'sm' | 'md';
}

export function ClientRatingBadge({ rating, size = 'md' }: ClientRatingBadgeProps) {
  if (!rating) return null;

  const sizeClasses = size === 'sm' ? 'w-5 h-5' : 'w-6 h-6';

  if (rating === 'good') {
    return (
      <Award
        className={`${sizeClasses} text-green-600 flex-shrink-0`}
        title="Bom Pagador - Paga adiantado ou no dia"
      />
    );
  }

  if (rating === 'regular') {
    return (
      <Minus
        className={`${sizeClasses} text-yellow-600 flex-shrink-0`}
        title="Pagador Regular - Paga até 2 dias após vencimento"
      />
    );
  }

  if (rating === 'bad') {
    return (
      <TrendingDown
        className={`${sizeClasses} text-red-600 flex-shrink-0`}
        title="Mau Pagador - Atrasa pagamentos frequentemente"
      />
    );
  }

  return null;
}
